export const CELL_FORMAT = {
    quantity: '#,##0;-#,##0;"-"',
    price: '₩#,##0;-₩#,##0;"-"',
};
/**
 * @description 셀에 숫자 형식 추가 함수 (천 단위 구분 쉼표)
 */
export function addNumFormat(sheet, cellAddress, formula) {
    const cell = sheet.getCell(cellAddress);
    cell.value = { formula };
    cell.numFmt = CELL_FORMAT.quantity;
}
/**
 * @description 셀에 가격 형식 추가 함수 (₩ + 천 단위 구분 쉼표)
 */
export function addPriceFormat(sheet, cellAddress, formula) {
    const cell = sheet.getCell(cellAddress);
    cell.value = { formula };
    cell.numFmt = CELL_FORMAT.price;
}
